import * as S from '@shared/CountChanger/CountChanger.styled'
import Image from 'next/image'
import React from 'react'

interface INumberChangerProps {
    increment: () => void
    decrement: () => void
    changeNumber: (value: number) => void
    value: number
}

export const NumberChanger = ({ increment, decrement, changeNumber, value }: INumberChangerProps) => {
    const changeValueHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        const valueInt = parseInt(event.target.value, 10)
        if (valueInt >= 0) {
            changeNumber(valueInt)
        }
    }
    return (
        <S.Container>
            <S.ButtonLeft data-basket-count={'minus'} onClick={decrement}>
                <Image
                    width={25}
                    height={25}
                    src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/minus.svg`}
                    alt={'-'}
                    priority={true}
                    sizes={'100%'}
                />
            </S.ButtonLeft>
            <S.Input data-basket-count={'custom'} value={value} onChange={changeValueHandler} />
            <S.ButtonRight data-basket-count={'plus'} onClick={increment}>
                <Image
                    width={25}
                    height={25}
                    src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/plus.svg`}
                    alt={'+'}
                    priority={true}
                    sizes={'100%'}
                />
            </S.ButtonRight>
        </S.Container>
    )
}
